import React, {Component} from "react";
import PropTypes from "prop-types";
import "../../styles/PaySlipFormStyles.css";
import i18next from "i18next";

class PaySlipFormAlivaria extends Component {
    constructor(props, context) {
        super(props, context);

        this.headersHdr = this.props.headerDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});

        this.headersTab = this.props.tableDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});
        this.nf = new Intl.NumberFormat( {maximumFractionDigits: 2});
        console.log(`locale: ${this.nf.resolvedOptions().locale}`);
    }

    componentDidMount() {
        //console.log(`Language: ${this.getLanguage()}`);
    }

    getHeader = (name, area = 'header') => {
        let source = area === 'table' ? this.headersTab : this.headersHdr;
        if (source && source[name]) {
            return source[name].replace("|", " ");
        }
    };

    //getLanguage = () => navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';

    getMoneyValue = (value) => {
        return value ? this.nf.format(value) : <>&nbsp;</>
    }

    renderHeaderInfo = (level1Info) => {
        return (
            <div id="paySlip_header">
                <table className="w-100">
                    <tbody>
                    <tr>
                        <td colSpan={3} className="paySlip_mn-report-value">
                            <span className="text-uppercase">{i18next.t("PaySlip")}</span> {i18next.t("To")} {this.props.monthName}
                        </td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("CompName")}</td>
                        <td className="paySlip_mn-report-value">{level1Info.CompName}</td>
                        <td className="paySlip_mn-report-value text-right">{this.getHeader("AsName")}: {level1Info.AsCode} {level1Info.AsName}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("Fio")}</td>
                        <td colSpan={2} className="paySlip_mn-report-value">{level1Info.TabNum} {level1Info.Fio}</td>
                    </tr>
                    </tbody>
                </table>
                <table className="w-100 table table-borderless">
                    <tbody>
                    <tr>
                        <td className="border">{this.getHeader("Salary")}</td>
                        <td className="border paySlip_mn-report-value">{this.getMoneyValue(level1Info.Salary)}</td>
                        <td className="">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="border">{this.getHeader("CashMoney")}</td>
                        <td className="border paySlip_mn-report-value">{this.getMoneyValue(level1Info.CashMoney)}</td>
                        <td className="text-right">{this.getHeader("ProfName")}: {level1Info.ProfName}</td>
                    </tr>
                    <tr>
                        <td className="border">{this.getHeader("PnDbtVal")}</td>
                        <td className="border paySlip_mn-report-value">{this.getMoneyValue(level1Info.PnDbtVal)}</td>
                        <td className="">&nbsp;</td>
                    </tr>
                    </tbody>
                </table>
                <table className="w-100 table table-bordered">
                    <tbody>
                    <tr>
                        <td>{i18next.t("PaySlip_1")}</td>
                        <td>{this.getHeader("PnLgtVal1")}</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.PnLgtVal1)}</td>
                        <td>{this.getHeader("PnLgtVal2")}</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.PnLgtVal2)}</td>
                        <td>{this.getHeader("PnLgtVal3")}</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.PnLgtVal3)}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    renderReportInfo = (level1Info, level2Info, level3Info) => {
        return (
            <>
                <table className="w-100 table table-bordered">
                    <thead>
                        <tr className="text-center">
                            <th rowSpan="2" className="align-middle">{this.getHeader("DbtName")}</th>
                            <th rowSpan="2" className="align-middle">{this.getHeader("DbtMonth")}</th>
                            <th colSpan="3" className="align-middle">{i18next.t("PaySlip_6")}</th>
                            <th rowSpan="2" className="align-middle">{this.getHeader("DbtSum")}</th>
                            <th rowSpan="2" className="align-middle">{this.getHeader("CrdName")}</th>
                            <th rowSpan="2" className="align-middle">{this.getHeader("CrdMonth")}</th>
                            <th rowSpan="2" className="align-middle">{this.getHeader("CrdSum")}</th>
                        </tr>
                        <tr>
                            <th className="align-middle">{this.getHeader("DbtPrc")}</th>
                            <th className="align-middle">{this.getHeader("DbtDay")}</th>
                            <th className="align-middle">{this.getHeader("DbtTime")}</th>
                        </tr>
                        <tr>
                            <th className="text-left" colSpan="6">{i18next.t("PaySlip_2")}</th>
                            <th className="text-left" colSpan="3">{i18next.t("PaySlip_3")}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        level2Info.map((item, i) => (
                            <tr key={i}>
                                <td className="text-left">{item.DbtName}</td>
                                <td>{item.DbtMonth}</td>
                                <td>{item.DbtPrc}</td>
                                <td>{item.DbtDay}</td>
                                <td>{item.DbtTime}</td>
                                <td>{this.getMoneyValue(item.DbtSum)}</td>
                                <td className="text-left">{item.CrdName}</td>
                                <td>{item.CrdMonth}</td>
                                <td>{this.getMoneyValue(item.CrdSum)}</td>
                            </tr>
                        ))
                    }
                        <tr>
                            <td colSpan="5" className="text-left">{this.getHeader("AllDbtSum1")}</td>
                            <td className="w-auto font-weight-bold">{this.getMoneyValue(level1Info.AllDbtSum1)}</td>
                            <td colSpan="2" className="text-left">{this.getHeader("AllCrdSum2")}</td>
                            <td className="w-auto font-weight-bold">{this.getMoneyValue(level1Info.AllCrdSum2)}</td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th className="text-left" colSpan="6">{i18next.t("PaySlip_4")}</th>
                            <th className="text-left" colSpan="3">{i18next.t("PaySlip_5")}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        level3Info.map((item, i) => (
                            <tr key={i}>
                                <td className="text-left">{item.DbtName}</td>
                                <td>{item.DbtMonth}</td>
                                <td>{item.DbtPrc}</td>
                                <td>{item.DbtDay}</td>
                                <td>{item.DbtTime}</td>
                                <td>{this.getMoneyValue(item.DbtSum)}</td>
                                <td className="text-left">{item.CrdName}</td>
                                <td>{item.CrdMonth}</td>
                                <td>{this.getMoneyValue(item.CrdSum)}</td>
                            </tr>
                        ))
                    }
                    <tr>
                        <td colSpan="5" className="text-left">{this.getHeader("AllDbtSum3")}</td>
                        <td className="w-auto font-weight-bold">{this.getMoneyValue(level1Info.AllDbtSum3)}</td>
                        <td colSpan="2" className="text-left">{this.getHeader("AllCrdSum4")}</td>
                        <td className="w-auto font-weight-bold">{this.getMoneyValue(level1Info.AllCrdSum4)}</td>
                    </tr>
                    </tbody>
                </table>
                {this.renderFooterInfo(level1Info)}
            </>
        );
    }

    renderFooterInfo = (level1Info) => {
        return (
            <table className="table table-bordered w-100 mt-2">
                <tbody>
                <tr>
                    <td>{level1Info.BegSaldoName}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldo)}</td>
                    <td>{level1Info.BegSaldoTnName}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldoTn)}</td>
                </tr>
                <tr>
                    <td>{this.getHeader("BegSaldoPn")}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldoPn)}</td>
                    <td>{this.getHeader("EndSaldoPn")}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldoPn)}</td>
                </tr>
                <tr>
                    <td colSpan="3">{this.getHeader("EndSaldo")}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldo)}</td>
                </tr>
                <tr>
                    <td colSpan="3">{this.getHeader("EndSaldoTn")}</td>
                    <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldoTn)}</td>
                </tr>
                </tbody>
            </table>
        );
    }

    render() {
        if (this.props.headerDataItem.dataTable().length === 0) {
            return null;
        }

        let level1Info = this.props.headerDataItem.getRow(0);
        let level2Info = this.props.tableDataItem.dataTable().filter(row => row.Level === 1);
        let level3Info = this.props.tableDataItem.dataTable().filter(row => row.Level === 2);

        return (
            <div id="paySlip_report">
                <div>{level1Info.MyComp}</div>
                {this.renderHeaderInfo(level1Info)}
                {this.renderReportInfo(level1Info, level2Info, level3Info)}
            </div>
        );
    }
}

PaySlipFormAlivaria.propTypes = {
    headerDataItem: PropTypes.object.isRequired,
    tableDataItem: PropTypes.object.isRequired,
    monthName: PropTypes.string
};

PaySlipFormAlivaria.defaultProps = {
    monthName: ""
};

export default PaySlipFormAlivaria;
